'use client';

import Link from 'next/link';
import Script from 'next/script';
import { useCallback, useEffect, useState } from 'react';

interface InstagramEmbedProps {
  url: string;
  className?: string;
}

const SCRIPT_ID = 'instagram-embed-script';

const InstagramEmbed = ({ url, className }: InstagramEmbedProps) => {

  const processEmbed = useCallback(() => {
    if (typeof window !== 'undefined' && (window as any)?.instgrm?.Embeds) {
      (window as any).instgrm.Embeds.process();
    }
  }, []);

  useEffect(() => {
    processEmbed();
  }, [url, processEmbed]);

  return (
    <div className={className}>
      <blockquote
        className="instagram-media"
        data-instgrm-permalink={url}
        data-instgrm-version="14"
        style={{ width: '100%', maxWidth: 540, margin: '0 auto' }}
      >
        <Link href={url} target='_blank' prefetch={false}>
          {url}
        </Link>
      </blockquote>
      <Script
        id={SCRIPT_ID}
        src="https://www.instagram.com/embed.js"
        strategy="lazyOnload"
        onLoad={processEmbed}
      />
    </div>
  );
};

export default InstagramEmbed;